interface Window {
  sdDataLayer: ISdDataLayer;
  sd: (action?: string) => void;
}

interface ISdDataLayer {
  linkType: string;
  events: string;
  location?: string;
}

class SubaruTagging {
  public constructor() {
    this.initialize();
  }

  private initialize() {
    // Check if event listeners are already attached
    const attachEventListenerToElement = (elem) => {
      if (!("eventListenerAttached" in elem.dataset)) {
        elem.dataset.eventListenerAttached = "true";
        this.attachEventListener(elem);
      }
    };

    const elements = document.querySelectorAll(
      `[data-tagging-event="linkClick"], a[href*="serviceappmt.aspx"]`
    );
    elements.forEach((elem) => {
      attachEventListenerToElement(elem);
    });

    // C2C event to listen to for SPA
    document.addEventListener("do.vehicleloadend", () => {
      const newElements = document.querySelectorAll(
        `[data-tagging-event="linkClick"], a[href*="serviceappmt.aspx"]`
      );
      newElements.forEach((elem) => {
        attachEventListenerToElement(elem);
      });
    });
  }

  private processScheduleServiceClicks() {
    window.sdDataLayer = {
      linkType: "",
      events: "scheduleServiceClick",
    };
    window.sd("send");
  }

  private processLinkClicks(elem) {
    let event = elem.dataset.taggingEvent;

    //if a child element is the target click, lookup the data-tagging-event
    if (!event) {
      elem = elem.closest("[data-tagging-event='linkClick']");
      event = elem.dataset.taggingEvent;
    }
    if (event) {
      const value = elem.dataset.taggingValue;
      window.sdDataLayer = {
        linkType: value,
        events: event,
      };
      //check for optional location
      const item = elem.dataset.taggingItem;
      if (item) {
        window.sdDataLayer.location = item;
      }
      window.sd("send");
    }
  }

  private attachEventListener(elem) {
    //service appointment links
    if (elem.tagName === "A" && elem.href?.includes("serviceappmt.aspx")) {
      elem.addEventListener("click", () => {
        this.processScheduleServiceClicks();
      });
    } else {
      elem.addEventListener("click", (elem) => {
        this.processLinkClicks(elem.target);
      });
    }
  }
}

//DoUtility loads after the head in the ShiftDigitalTrackerWithDatalayer BuildPageLoadContent
//so we can't use it here :(
if (document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", () => new SubaruTagging());
} else {
  new SubaruTagging();
}
